import { is99, isFromBDAPP } from '@/utils/common/env'
const bapiUrlIn99 = 'https://b.99app.com'
const bapiUrlInSSL = 'https://b.didi-food.com'
// 如果来自 BDAPP 跳转，即便是巴西国家商户，域名依旧使用老的SSL的(因为ios容器，有itp，bdapp没法跨域给99app域名种cookie)
const baseApi = isFromBDAPP ? bapiUrlInSSL : is99 ? bapiUrlIn99 : bapiUrlInSSL

export default {
  NODE_ENV: process.env.NODE_ENV,
  LOGIN_URL: 'https://page.didiglobal.com/public-biz/pc-login/3.0.1/index.html',
  BASE_API: baseApi,
}
